/*
 * Copyright © 2017-2021 Skale Education Inc. - All Rights Reserved
 */

import React, { useState } from "react";
import { View } from "react-native";

import { Button, FadeInOutView, Text } from "UpduoLibrary";
import { skalePrimaryBlue } from "config/UpduoColors";

interface DeviceSwitchProps {
  onSwitch: Function;
}

export default function DeviceSwitch({ onSwitch }: DeviceSwitchProps) {
  const [buttonDisabled, setButtonDisabled] = useState(false);

  return (
    <View>
      <FadeInOutView
        style={{
          flex: 1,
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <View style={{ padding: 50 }}>
          <Text
            style={{
              textAlign: "center",
            }}
          >
            {"You are using Upduo on another device."}
          </Text>
          <Text
            style={{
              textAlign: "center",
            }}
          >
            {"Switch to this device instead?"}
          </Text>
        </View>
        <Button
          disabled={buttonDisabled}
          width={220}
          text={"Use Upduo Here"}
          onPress={() => {
            setButtonDisabled(true);
            onSwitch();
          }}
          height={36}
          borderWidth={1}
          borderColor={skalePrimaryBlue}
        />
      </FadeInOutView>
    </View>
  );
}
